var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Provincias","storeName":"Provinces","labelAddNew":"Agregar","sortable":"","canSearch":"","next-link":"/admin/tags","breadcrumbs":[
    {
      text: 'Spots y vehículos',
      disabled: false,
      href: '/admin/provinces'
    },
    {
      text: 'Provincias',
      disabled: false,
      href: '#'
    }
  ]},scopedSlots:_vm._u([{key:"cities",fn:function({ item }){return [_c('v-btn',{staticClass:"my-1 btn-black btn-round-md",attrs:{"elevation":"0","rounded":"","color":"primary"},on:{"click":function($event){return _vm.$router.push('/admin/provinces/' + item.id + '/cities')}}},[_vm._v(" Ciudades ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }